import { render, staticRenderFns } from "./MenuStudentCreateOrEdit.vue?vue&type=template&id=bb82a73c&"
import script from "./MenuStudentCreateOrEdit.vue?vue&type=script&lang=js&"
export * from "./MenuStudentCreateOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./MenuStudentCreateOrEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports